import { useDocumentThreadsQuery, useThreadScopeQuery } from "@/stores/documents/comments/queries";
import { useOptionalStores } from "@/stores/useStores";

/**
 * The live open-thread count for the viewer rail's header. It reads the same
 * cache entries the thread list does, so no second request is made.
 */
export function useDocumentOpenCommentCount(documentId: number | null): number {
  const stores = useOptionalStores();
  const scopeQuery = useThreadScopeQuery(documentId);
  const threads = useDocumentThreadsQuery(
    scopeQuery.data ?? null,
    stores?.userStore.userProfile?.id ?? null
  );
  return threads.open.length;
}
